import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const Footer = ({ footer = {}, config = {} }) => {
  const brand = config.brandName || "Ecentra";
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden border-t border-border bg-primary text-primary-foreground grain">
      <div className="relative mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent text-accent-foreground"><Leaf className="h-5 w-5" /></span>
              <span className="font-display text-xl font-semibold">{brand}</span>
            </div>
            <p className="mt-3 text-sm text-primary-foreground/70">{footer.tagline}</p>
          </div>

          <div className="flex flex-wrap gap-x-10 gap-y-4">
            <div className="flex flex-col gap-2">
              <p className="text-xs font-semibold uppercase tracking-wider text-primary-foreground/50">Discover</p>
              <button onClick={() => scrollToId("products")} className="text-left text-sm text-primary-foreground/80 hover:text-primary-foreground">Product</button>
              <button onClick={() => scrollToId("join")} className="text-left text-sm text-primary-foreground/80 hover:text-primary-foreground">Opportunity</button>
              <button onClick={() => scrollToId("faq")} className="text-left text-sm text-primary-foreground/80 hover:text-primary-foreground">FAQ</button>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-xs font-semibold uppercase tracking-wider text-primary-foreground/50">Contact</p>
              <button onClick={() => scrollToId("contact")} className="text-left text-sm text-primary-foreground/80 hover:text-primary-foreground">Mag-message</button>
              <Link to="/admin" className="text-left text-sm text-primary-foreground/80 hover:text-primary-foreground" data-testid="footer-admin-link">Distributor login</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-primary-foreground/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {brand}. Independent distributor site.</p>
          <p data-testid="footer-disclaimer">{footer.disclaimer || "Hindi ito ang corporate HQ website. Results may vary. Hindi gamot. Hindi panggamot."}</p>
        </div>
      </div>
    </footer>
  );
};
